import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import {
  Autocomplete,
  Button as MuiButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Checkbox,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Box
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ClearIcon from '@mui/icons-material/Clear';
import { createProject, fetchProjects } from './ProjectSlice';
import { fetchRoles } from '../UserManagement/UserSlice';
import { searchObject } from '../../app/utils';
// import bgImage from '../../assets/ProjectCreationBackground.png';
import backgroundImage from '../../assets/afroimage.png';


type Props = {
  open: boolean;
  onClose: () => void;
};

function NewProject({ open, onClose }: Props) {
  const { users, userRoles } = useAppSelector((state) => state.usermanagement);
  const { user_details } = useAppSelector((state) => state.appData);

  const defaultUser = () => {
    return users.filter((user:any) => (
      user?.userDetails?.name === user_details?.name
    )).map((user:any) => (user.email));
  };

  const [label, setLabel] = useState('');
  const [description, setDescription] = useState('');
  const [tags, setTags] = useState<string[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>(defaultUser() ?? []);
  const [selectedAdmins, setSelectedAdmins] = useState<string[]>(defaultUser() ?? []);
  const [keyedUsers, setKeyedUsers] = useState<any[]>([]);
  const [searchUserString, setSearchUserString] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSelectedUsers = (event: React.MouseEvent<unknown>, id: string) => {
    const selectedIndex = selectedUsers.indexOf(id);
    const adminIndex = selectedAdmins.indexOf(id);
    let newSelected: string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedUsers, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedUsers.slice(1));
    } else if (selectedIndex === selectedUsers.length - 1) {
      newSelected = newSelected.concat(selectedUsers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedUsers.slice(0, selectedIndex),
        selectedUsers.slice(selectedIndex + 1)
      );
    }
    setSelectedUsers(newSelected);

    if(adminIndex > -1) {
      let newAdminArray = Array.from(selectedAdmins);
      newAdminArray.splice(adminIndex, 1);
      setSelectedAdmins(newAdminArray);
    }
  };

  const handleSelectedAdmins = (event: any, email: string) => {
    const selectedIndex = selectedAdmins.indexOf(email);

    if(event.target.value === 'admin' && selectedIndex === -1) {
      setSelectedAdmins([...selectedAdmins, email])
    }

    if(event.target.value === 'consumer' && selectedIndex > -1) {
      let newAdminArray = Array.from(selectedAdmins);
      newAdminArray.splice(selectedIndex, 1);
      setSelectedAdmins(newAdminArray);
    }
  };

  const isSelected = (email: string) => selectedUsers.indexOf(email) !== -1;

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchRoles());
  }, []);

  useEffect(() => {
    let i = 0;
    let tmpDataSet: object[] = [];
    users.forEach((d) => {
      tmpDataSet.push({ key: i++, ...d });
    });
    setKeyedUsers(tmpDataSet);
  }, [users]);

  const filteredUsers = keyedUsers.filter(
    (user) => {
      return searchObject(searchUserString, user, ['email', 'name']);
    },
    [searchUserString]
  );

  const submitProject = (e: any) => {
    setIsSubmitting(true);
    dispatch(createProject({ 
      label, 
      description, 
      tags, 
      users: selectedUsers, 
      admins: selectedAdmins 
    }))
      .then(() => dispatch(fetchProjects()))
      .finally(() => {
        onClose();
        setIsSubmitting(false);
      });
    e.preventDefault();
  };

  const handleTagDelete = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          submitProject(e);
        }}
      >
        <Dialog
          PaperProps={{
            style: {
              backgroundColor: 'var(--color-ocean-dark)',
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: 'cover',
              boxShadow: 'none',
              border: '1px solid var(--color-offwhite)',
              borderRadius: 10,
              maxHeight: '700px',
              height: '100%'
            }
          }}
          fullWidth
          maxWidth="lg"
          open={open}
          onClose={onClose}
        >
          {/* <DialogTitle
            className="bold-text"
            fontSize={32}
            textAlign="center"
            color="var(--color-ocean-highlight)"
          >
            Create A Community
          </DialogTitle> */}
          <DialogContent>
            <Grid px={5} sx={{ width: '100%' }} container spacing={4}>
              <Grid flexDirection="row" xs={6}>
                <Typography
                  sx={{ color: 'var(--color-ocean-highlight)' }}
                  fontSize={28}
                  variant="h4"
                  mb={1}
                >
                  Community Details
                </Typography>
                <TextField
                  id="Community name"
                  required
                  className="ocean"
                  label="Community name"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={label}
                  onChange={(e) => {
                    setLabel(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': { borderColor: 'black' },
                      '&:hover fieldset': { borderColor: 'black' },
                      '&.Mui-focused fieldset': { borderColor: 'black' },
                    },
                    input: { color: 'black' },
                  }}
                  margin="normal"
                />
                <TextField
                  id="community-description"
                  required
                  className="ocean"
                  label="community Description"
                  variant="outlined"
                  multiline
                  rows={4.6}
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                  }}
                  margin="normal"
                />
                <Autocomplete
                  className="ocean"
                  multiple
                  freeSolo
                  value={tags}
                  fullWidth
                  options={[]}
                  clearIcon={<ClearIcon sx={{ color: 'white' }} fontSize="small" />}
                  onChange={(e, newval, reason) => {
                    setTags(newval);
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        sx={{ backgroundColor: 'rgba(228, 219, 233, 0.55)' }}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={() => handleTagDelete(option)}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      className="ocean"
                      {...params}
                      id="community-tags"
                      variant="outlined"
                      label="community Tags"
                      placeholder="Type and press enter"
                      InputLabelProps={{
                        shrink: true
                      }}
                      margin="normal"
                    />
                  )}
                />
              </Grid>

              <Grid flexDirection="row" xs={6}>
                <Typography
                  sx={{ color: 'var(--color-ocean-highlight)' }}
                  fontSize={28}
                  variant="h4"
                  mb={1}
                >
                  Select Members
                </Typography>
                <Box
                  display="flex"
                  flexDirection="column"
                  sx={{
                    backgroundColor: 'var(--color-ocean-dark)',
                    border: '1px solid var(--color-dark-gray)',
                    borderRadius: '5px',
                    padding: '10px',
                    maxHeight: '500px',
                    height: '100%'
                  }}
                >
                  <TextField
                    id="community-memebrs-search"
                    className="ocean"
                    variant="outlined"
                    placeholder="Search"
                    type="search"
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={searchUserString}
                    onChange={(e) => {
                      setSearchUserString(e.target.value);
                    }}
                  />
                  <TableContainer>
                    <Table>
                      <TableBody>
                        {filteredUsers.map((user, index) => {
                          const isItemSelected = isSelected(user.email);
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={user.id}
                              selected={isItemSelected}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell 
                                padding="checkbox" 
                                onClick={(event) => {
                                  if(user.userDetails?.name === user_details?.name) return;
                                  handleSelectedUsers(event, user.email);
                                }}
                              >
                                <Checkbox
                                  id={labelId}
                                  checked={isItemSelected}
                                  inputProps={{
                                    'aria-labelledby': labelId
                                  }}
                                  style={{ color: 'var(--color-ocean-highlight)' }}
                                />
                              </TableCell>
                              <TableCell width={150} align="left" sx={{ color: 'white' }}>
                                {user.email}
                              </TableCell>
                              <TableCell align="right">
                                {
                                  isItemSelected &&
                                  <TextField
                                    className="ocean"
                                    size="small"
                                    id="member-role-select"
                                    select
                                    label="User Role"
                                    defaultValue={user.userDetails?.name === user_details?.name ? 'admin' : 'consumer'}
                                    disabled={user.userDetails?.name === user_details?.name}
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    sx={{minWidth: '120px', textAlign: 'left'}}
                                    onChange={(event) => handleSelectedAdmins(event, user.email)}
                                  >
                                    {
                                      Object.values(userRoles).map(role => (
                                        role !== 'sysadmin' &&
                                        <MenuItem className="ocean" key={role} value={role}>{role}</MenuItem>
                                      ))
                                    }
                                  </TextField>
                                }
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              variant="outlined"
              size="large"
              className="ocean secondary-button bold-text"
              onClick={onClose}
              type="button"
            >
              Cancel
            </MuiButton>
            <MuiButton
              variant="contained"
              size="large"
              className="ocean primary-button bold-text"
              onClick={(e) => {
                submitProject(e);
              }}
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Submit'}
            </MuiButton>
          </DialogActions>
        </Dialog>
      </form>
    </>
  );
}

export default NewProject;
